<template>
  <svg class="suit-morph" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <path :d="currentPath" :fill="currentColor" />
  </svg>
</template>

<script>
const SUIT_PATHS = [
  // Heart (outer contour)
  'm515.32,215.93h0c-.92,0-1.77-.51-2.2-1.32l-.4-.75c-3.65-6.99-13.17-14.59-23.25-22.64-16.71-13.34-35.64-28.46-38.67-48.13-3.07-19.95,4.89-42.13,29.59-46.69.06-.01.13-.02.19-.03,1.86-.2,3.69-.29,5.44-.29,16.9,0,25.33,8.91,29.31,15.73,3.98-6.82,12.41-15.73,29.31-15.73,1.75,0,3.58.1,5.44.29.06,0,.13.02.19.03,24.71,4.56,32.66,26.74,29.59,46.69-3.03,19.67-21.97,34.78-38.67,48.12-10.08,8.05-19.6,15.65-23.24,22.62l-.42.78c-.44.81-1.28,1.31-2.2,1.31Z',
  // Diamond (outer contour)
  'm226.65,222.02c-.95,0-1.83-.54-2.25-1.4-11.15-22.76-33.82-53.6-50.53-68.77-.52-.47-.82-1.15-.82-1.85s.3-1.38.82-1.85c16.71-15.15,39.37-46,50.53-68.77.42-.86,1.29-1.4,2.25-1.4s1.83.54,2.25,1.4c11.16,22.77,33.82,53.61,50.53,68.77.52.47.82,1.15.82,1.85s-.3,1.38-.82,1.85c-16.71,15.16-39.38,46.01-50.53,68.77-.42.86-1.29,1.4-2.25,1.4Z',
  // Club (outer contour)
  'm387.11,214.63h-39.77c-1.03,0-1.95-.63-2.33-1.58-.38-.96-.13-2.05.62-2.75,10.82-10.06,13.82-17.01,14.51-24.97-6.03,8.91-16.24,14.64-27.46,14.64-18.27,0-33.14-14.87-33.14-33.14s14.87-33.14,33.14-33.14c1.79,0,3.56.15,5.32.43-2.57-4.79-3.94-10.15-3.94-15.62,0-18.28,14.87-33.14,33.15-33.14s33.13,14.87,33.13,33.14c0,5.48-1.37,10.85-3.93,15.63,1.76-.29,3.54-.43,5.32-.43,18.27,0,33.14,14.87,33.14,33.14s-14.87,33.14-33.14,33.14c-11.34,0-21.59-5.78-27.58-14.75.63,7.83,3.6,14.74,14.46,24.91.6.46.99,1.18.99,2,0,1.38-1.12,2.5-2.5,2.5Z',
  // Spade (outer contour)
  'm108.23,219.2h-42.77c-1.03,0-1.98-.65-2.36-1.61-.63-1.61.47-2.66,1.26-3.42,1.95-1.86,7.87-7.52,11.75-18.08.64-1.73,1.19-4.09,1.71-6.57-6.14,4.3-13.38,6.61-20.98,6.61l-.44-.02c-9.85-.07-19.16-3.88-26.14-10.73-7.02-6.89-10.85-16-10.76-25.65.14-16.42,11.22-25.16,24.04-35.28,2.54-2,5.02-3.96,7.6-6.09,17.11-14.22,30.99-32.84,33.6-36.43.55-.76,1.26-1.14,2.1-1.14,1.27,0,1.91.87,2.15,1.2,2.64,3.61,16.66,22.33,33.56,36.37,2.49,2.07,4.91,3.98,7.59,6.09,12.83,10.12,23.91,18.87,24.05,35.28.08,9.65-3.74,18.76-10.76,25.65-6.98,6.84-16.3,10.65-26.23,10.73h-.27s0,.01,0,.01c-7.67,0-14.93-2.31-21.08-6.61.52,2.48,1.08,4.85,1.71,6.58,3.88,10.55,9.81,16.21,11.76,18.08.8.76,1.89,1.81,1.27,3.42-.37.94-1.29,1.58-2.3,1.61-.02,0-.04,0-.06,0Z'
]

const SUIT_COLORS = ['#c0392b', '#c0392b', '#2c3e50', '#2c3e50']
const NUM_POINTS = 300
const MORPH_DURATION = 2500

function samplePath(pathD, numPoints) {
  const svgNs = 'http://www.w3.org/2000/svg'
  const svg = document.createElementNS(svgNs, 'svg')
  const path = document.createElementNS(svgNs, 'path')
  path.setAttribute('d', pathD)
  svg.appendChild(path)
  document.body.appendChild(svg)

  const totalLength = path.getTotalLength()
  const points = []
  for (let i = 0; i < numPoints; i++) {
    const pt = path.getPointAtLength((i / numPoints) * totalLength)
    points.push({ x: pt.x, y: pt.y })
  }

  document.body.removeChild(svg)
  return points
}

function normalizePoints(points) {
  let minX = Infinity
  let minY = Infinity
  let maxX = -Infinity
  let maxY = -Infinity
  for (const p of points) {
    if (p.x < minX) minX = p.x
    if (p.y < minY) minY = p.y
    if (p.x > maxX) maxX = p.x
    if (p.y > maxY) maxY = p.y
  }
  const w = maxX - minX
  const h = maxY - minY
  const scale = Math.max(w, h)
  const offsetX = (scale - w) / 2
  const offsetY = (scale - h) / 2
  const padding = 4
  const usable = 100 - padding * 2
  return points.map(p => ({
    x: padding + ((p.x - minX + offsetX) / scale) * usable,
    y: padding + ((p.y - minY + offsetY) / scale) * usable
  }))
}

function pointsToPath(points) {
  if (!points.length) return ''
  let d = `M${points[0].x.toFixed(2)},${points[0].y.toFixed(2)}`
  for (let i = 1; i < points.length; i++) {
    d += `L${points[i].x.toFixed(2)},${points[i].y.toFixed(2)}`
  }
  return d + 'Z'
}

function lerpPoints(a, b, t) {
  return a.map((pa, i) => ({
    x: pa.x + (b[i].x - pa.x) * t,
    y: pa.y + (b[i].y - pa.y) * t
  }))
}

function lerpColor(hex1, hex2, t) {
  const r1 = parseInt(hex1.slice(1, 3), 16)
  const g1 = parseInt(hex1.slice(3, 5), 16)
  const b1 = parseInt(hex1.slice(5, 7), 16)
  const r2 = parseInt(hex2.slice(1, 3), 16)
  const g2 = parseInt(hex2.slice(3, 5), 16)
  const b2 = parseInt(hex2.slice(5, 7), 16)
  const r = Math.round(r1 + (r2 - r1) * t)
  const g = Math.round(g1 + (g2 - g1) * t)
  const b = Math.round(b1 + (b2 - b1) * t)
  return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`
}

function easeInOut(t) {
  return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2
}

export default {
  name: 'SuitMorph',
  data() {
    return {
      currentPath: '',
      currentColor: SUIT_COLORS[0]
    }
  },
  mounted() {
    this.suitPoints = SUIT_PATHS.map(
      d => normalizePoints(samplePath(d, NUM_POINTS))
    )
    this.fromIndex = 0
    this.toIndex = 1
    this.progress = 0
    this.lastTime = performance.now()

    this.currentPath = pointsToPath(this.suitPoints[0])
    this.animFrameId = requestAnimationFrame(this.animate)
  },
  beforeUnmount() {
    if (this.animFrameId) {
      cancelAnimationFrame(this.animFrameId)
    }
  },
  methods: {
    animate(now) {
      const delta = now - this.lastTime
      this.lastTime = now
      this.progress += delta / MORPH_DURATION

      if (this.progress >= 1) {
        this.progress -= 1
        this.fromIndex = this.toIndex
        this.toIndex = (this.toIndex + 1) % SUIT_PATHS.length
      }

      const t = easeInOut(this.progress)
      const morphed = lerpPoints(
        this.suitPoints[this.fromIndex],
        this.suitPoints[this.toIndex],
        t
      )
      this.currentPath = pointsToPath(morphed)
      this.currentColor = lerpColor(
        SUIT_COLORS[this.fromIndex],
        SUIT_COLORS[this.toIndex],
        t
      )

      this.animFrameId = requestAnimationFrame(this.animate)
    }
  }
}
</script>

<style scoped>
.suit-morph {
  width: 10rem;
  height: 10rem;
  filter: drop-shadow(0 0.25rem 0.5rem rgba(0, 0, 0, 0.15));
}

@media (prefers-reduced-motion: reduce) {
  .suit-morph {
    visibility: hidden;
  }
}
</style>
